<template>
  <div>
    <tooltip label="Check" type="default" placement="right">
      <a class="button button-table is-small" @click="check()">
        <i class="fa fa-check"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      // refresh () {
      //   this.$http.post(this.$store.state.config.apiURL + '/services/refresh', {booking_id: this.data.booking}).then((response) => {
      //     this.message('success', 'Success', 'The booking ' + this.data.api_booking_id + ' was successfully imported')
      //   }, (response) => {
      //     this.message('danger', 'Error', 'The booking ' + this.data.booking_id + ' does not exist')
      //   })
      // },
      check () {
        if (window.confirm('Are you sure you want to check?')) {
          this.$http.post(this.$store.state.config.apiURL + '/bookings_missing/check', {id: this.data.id}).then((response) => {
            this.message('success', 'Success', 'The booking ' + this.data.api_booking_id + ' was successfully checked')
          }, (response) => {
            this.message('danger', 'Error', 'The booking ' + this.data.booking_id + ' does not exist')
          })
        }
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
        this.$parent.$parent.reload()
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// BookingsMissingTableButtons.vue?8a2a42b0